import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "notification-inline__body" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "notification-inline__content" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseNotificationInline',
  props: {
    type: { default: 'error' },
    show: { type: Boolean }
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["BaseNotificationInline notification-inline", `is--${_ctx.type}`])
      }, [
        _createElementVNode("p", _hoisted_1, [
          (_ctx.type === 'error')
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "svg-icon notification-inline__icon",
                alt: "exclamation-circle-icon",
                innerHTML: require(`!!raw-loader!images/svg-icons/fa-circle-exclamation.svg`).default
              }, null, 8, _hoisted_2))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                alt: "info-circle-icon",
                class: "svg-icon notification-inline__icon",
                innerHTML: require(`!!raw-loader!images/svg-icons/fa-triangle-exclamation.svg`).default
              }, null, 8, _hoisted_3)),
          _createElementVNode("span", _hoisted_4, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})